<template>
  <div class="space-y-2">
    <!--  -->
    <div
      v-for="launchGroup in data.ad_groups"
      :key="launchGroup.id"
      class="bg-background-normal rounded-xl"
    >
      <!-- Header -->
      <div class="flex items-center w-full p-2 gap-1">
        <button
          class="p-1 rounded-md hover:bg-background-pressed transition-colors"
          @click="handleCategoryCollapse(launchGroup.group_by)"
        >
          <ChevronIcon
            class=" transition-transform transform text-icon-normal"
            :class="{ '-rotate-90': !hiddenCategorizedRows?.[launchGroup.group_by] }"
          />
        </button>
        <BaseText
          type="label"
          size="sm"
          class="text-text-muted"
        >
          {{ formatLaunchDate(launchGroup.group_by) }}
        </BaseText>
        <BaseText
          size="xs"
          class="text-text-subdued ml-2"
        >
          {{ launchGroup.ads.length }} New Creatives
        </BaseText>
      </div>
      <Transition name="fade">
        <div
          v-if="hiddenCategorizedRows?.[launchGroup.group_by]"
          class="grid-graph-container gap-1 mt-1 p-1"
        >
          <div
            v-for="ad in launchGroup.ads"
            :key="ad.id"
          >
            <GridGraphCard
              :is-ad-level="true"
              :data="getAdItem(ad)"
              :selected-kpis="selectedColumns"
              :data-summary="data.summary_stats"
              @showDetailsDrawer="$emit('showDetailsDrawer', ad)"
            />
          </div>
        </div>
      </Transition>
    </div>
  </div>
</template>

<script>
import GridGraphCard from '../graphs/grid/GridGraphCard.vue'
// Icons
import ChevronIcon from '../../globals/Icons/ChevronIcon.vue'
export default {
  name: 'LensCreativeGrid',
  components: {
    GridGraphCard,
    // Icons
    ChevronIcon
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    selectedColumns: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      hiddenCategorizedRows: {}
    }
  },
  mounted () {
    const firstLaunchGroup = this.data.ad_groups[0]
    // Init first group expand
    if (firstLaunchGroup?.group_by) {
      this.$set(this.hiddenCategorizedRows, firstLaunchGroup.group_by, true)
    }
  },
  methods: {
    handleCategoryCollapse (id) {
      if (this.hiddenCategorizedRows[id]) {
        this.$delete(this.hiddenCategorizedRows, id)
      } else {
        this.$set(this.hiddenCategorizedRows, id, true)
      }
    },
    getAdItem (ad) {
      return {
        ...ad,
        group_by: ad.ad_name
      }
    },
    formatLaunchDate (launchDate) {
      return new Date(launchDate).toLocaleDateString('en-US', { month: 'long', day: 'numeric' })
    }
  }
}
</script>

<style scoped>
.grid-graph-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(275px, 1fr));
  gap: 4px;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 150ms;
}

.fade-enter,
.fade-leave-to .fade-leave-active {
  opacity: 0;
  transform: translateY(-1rem);
}
</style>
